// extracted by mini-css-extract-plugin
export default {"groupItem":"gn9QX","title":"uQG07"};